import { SortDescriptor } from '@ui/Table';
import { useTranslation } from 'react-i18next';
import { Statistic } from './types';

interface Props {
    statistic: Statistic;
    sortDescriptor: SortDescriptor;
}

const Statistics = ({ statistic }: Props) => {
    const { t } = useTranslation('datatable');
    if (statistic.totalItems <= 0) return null;

    return (
        <div className="tw-flex tw-h-min tw-items-baseline tw-justify-around tw-rounded-xl tw-bg-accents-2 tw-px-6 tw-py-2 tw-text-accents-9">
            <div className="tw-flex tw-items-center tw-gap-2">
                {/*<FontAwesomeIcon icon={faCheckSquare} />*/}
                <span className="tw-align-middle tw-text-lg tw-font-semibold tw-leading-[1.1rem]">
                    {t('statistics.selected')}: {statistic.selectedItems === 'all' ? statistic.totalItems : statistic.selectedItems}
                </span>
            </div>
            <div className="tw-flex tw-items-center tw-gap-2">
                {/*<FontAwesomeIcon icon={faSquare} />*/}
                <span className="tw-align-middle tw-text-lg tw-font-semibold tw-leading-[1.1rem]">
                    {t('statistics.total')}: {statistic.totalItems}
                </span>
            </div>
        </div>
    );
};

export default Statistics;
